import { useQuery } from '@tanstack/react-query';
import { useUser } from '@clerk/clerk-react';
import { certificationService, InterestedFreelancer } from '@/lib/api/services/certification.service';

export function useInterestedFreelancers(filters?: {
  skills?: string;
  timezone?: string;
  location?: string;
}) {
  const { user } = useUser();

  // filters === undefined means "don't fetch" (tab not active)
  // filters === {} means "fetch all, no filters applied"
  const isEnabled = !!user?.id && filters !== undefined;

  const {
    data: freelancers = [],
    isLoading,
    error,
  } = useQuery<InterestedFreelancer[]>({
    queryKey: ['interested-freelancers', filters],
    queryFn: () => certificationService.getInterestedFreelancers(
      filters && Object.keys(filters).length > 0 ? filters : undefined
    ),
    enabled: isEnabled,
    staleTime: 2 * 60 * 1000,
  });

  return {
    freelancers,
    isLoading: isEnabled && isLoading,
    error,
  };
}
